import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ChatbotService {
  private chatbotOpenSubject = new BehaviorSubject<boolean>(false);
  public chatbotOpen$ = this.chatbotOpenSubject.asObservable();

  private chatbotModeSubject = new BehaviorSubject<'side' | 'over'>('side');
  public chatbotMode$ = this.chatbotModeSubject.asObservable();

  private chatbotWidthSubject = new BehaviorSubject<string>('400px');
  public chatbotWidth$ = this.chatbotWidthSubject.asObservable();

  private chatbotMinimizedSubject = new BehaviorSubject<boolean>(false);
  public chatbotMinimized$ = this.chatbotMinimizedSubject.asObservable();

  constructor() {}

  get chatbotOpen(): boolean {
    return this.chatbotOpenSubject.value;
  }

  get chatbotMode(): 'side' | 'over' {
    return this.chatbotModeSubject.value;
  }

  get chatbotWidth(): string {
    return this.chatbotWidthSubject.value;
  }

  get chatbotMinimized(): boolean {
    return this.chatbotMinimizedSubject.value;
  }

  toggleChatbot(): void {
    this.chatbotOpenSubject.next(!this.chatbotOpenSubject.value);
  }

  openChatbot(): void {
    this.chatbotOpenSubject.next(true);
  }

  closeChatbot(): void {
    this.chatbotOpenSubject.next(false);
    this.chatbotMinimizedSubject.next(false); // Reset minimized state when fully closed
  }

  setChatbotMode(mode: 'side' | 'over'): void {
    this.chatbotModeSubject.next(mode);
  }

  setChatbotWidth(width: string): void {
    this.chatbotWidthSubject.next(width);
  }

  onChatbotOpenedChange(opened: boolean): void {
    this.chatbotOpenSubject.next(opened);
  }

  minimizeChatbot(): void {
    this.chatbotMinimizedSubject.next(true);
    this.chatbotOpenSubject.next(false);
  }

  restoreChatbot(): void {
    this.chatbotMinimizedSubject.next(false);
    this.chatbotOpenSubject.next(true);
  }
}
